@if (debouncedEmpty()) {
  @if (!store || store.stateView.empty) {
    <section class="search-results-tool-empty">
      <h4>
        <strong>{{
          'igo.integration.searchResultsTool.noResults' | translate
        }}</strong>
      </h4>
      <p>
        <strong>{{
          'igo.integration.searchResultsTool.doSearch' | translate
        }}</strong>
      </p>
      <div
        [innerHTML]="
          'igo.integration.searchResultsTool.examples'
            | translate
            | sanitizeHtml
        "
      ></div>
    </section>
  }
} @else {
  @let feature = this.feature();
  <igo-flexible
    #topPanel
    initial="100%"
    initialMobile="100%"
    collapsed="calc(100% - 48px)"
    collapsedMobile="calc(100% - 48px)"
    expanded="60%"
    expandedMobile="60%"
    [state]="feature ? topPanelState : 'initial'"
  >
    <div class="igo-content">
      <igo-search-results
        [store]="store"
        [showIcons]="showIcons()"
        [term]="term"
        [termSplitter]="termSplitter"
        [settingsChange$]="settingsChange$"
        placeholder="false"
        (resultFocus)="onResultFocus($event)"
        (resultSelect)="onResultSelect($event)"
        (resultUnfocus)="onResultUnfocus($event)"
        (resultMouseenter)="onResultFocus($event)"
        (resultMouseleave)="onResultUnfocus($event)"
        (moreResults)="onSearch($event)"
        [map]="map"
      >
        <ng-template #igoSearchItemToolbar let-result="result">
          <igo-search-add-button
            [map]="map"
            [store]="store"
            [stores]="stores"
            [layer]="result"
            [saveSearchResultInLayer]="saveSearchResultInLayer"
          />
        </ng-template>
      </igo-search-results>
    </div>
    <div igoFlexibleFill class="igo-content">
      @if (feature) {
        <igo-panel
          [title]="featureTitle"
          (click)="toggleTopPanel($event)"
          [cursorPointer]="true"
        >
          <button
            mat-icon-button
            panelLeftButton
            class="igo-icon-button"
            (click)="toggleTopPanel()"
          >
            <mat-icon>{{
              (topPanelState$ | async) === 'collapsed'
                ? 'arrow_upward'
                : 'arrow_downward'
            }}</mat-icon>
          </button>
          @if (feature.geometry) {
            <button
              mat-icon-button
              panelRightButton
              class="igo-icon-button"
              [matTooltip]="
                ((isSelectedResultOutOfView$ | async)
                  ? 'igo.integration.searchResultsTool.zoomOnFeatureTooltipOutOfView'
                  : 'igo.integration.searchResultsTool.zoomOnFeatureTooltip'
                ) | translate
              "
              matTooltipShowDelay="500"
              (click)="zoomToFeatureExtent()"
            >
              <mat-icon
                aria-hidden="false"
                [matBadge]="(isSelectedResultOutOfView$ | async) ? '!' : ''"
                matBadgeColor="accent"
                matBadgeSize="small"
                [matBadgeHidden]="
                  (isSelectedResultOutOfView$ | async) === false
                "
                >zoom_in</mat-icon
              >
            </button>
          }
          <igo-feature-details
            igoFeatureDetailsDirective
            [feature]="feature"
            [map]="map"
            [toolbox]="toolState.toolbox"
            (routingEvent)="getRoute()"
          />
        </igo-panel>
      }
    </div>
  </igo-flexible>
}
